var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '../../node_modules/swiper/swiper-bundle.js';

const app = {
    /** Initialize */
    init() {

        // Open search overlay
        this.toggleSearchOverlay();

        // Toggle Subnavigation
        this.toggleSubnavigation();

        // Fade sections in on scroll
        this.fadeInOnScroll();

        // Init swiper
        this.initSwiperSliders();

        // Pageheader scroll
        this.pageheaderScroll();

        this.toggleActiveFilterStates();

        this.removeAndShowNavigationOnScroll();

        // Open mobile appointment pop-up
        this.openMobileAppointment();

        // Smooth anchor
        this.smoothAnchor();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $('.hamburger').toggleClass('is-active');
        $('body').toggleClass('is-locked');
        $('.navigation-items').toggleClass('is-visible');
        $('.navigation-overlay').toggleClass('is-visible');
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    /** Open search overlay */
    toggleSearchOverlay() {

        $('.toggle-search-box, .search-box .close-search-box').click(function (e) {
            e.preventDefault();
            $(".search-box").toggleClass('is-opened');
        });
    },

    /** Toggle Subnavigation */
    toggleSubnavigation() {

        if ($(window).width() < 1024) {

            $('ul.navigation-list > li.has-children > a.navlink > span.toggle-subnav').click(function (e) {
                e.preventDefault();
                $(this).parent().parent().toggleClass('is-opened').find('> ul').slideToggle();
            });
        }
    },

    /** Fade sections in on scroll */
    fadeInOnScroll() {
        $.fn.initFadeIn = function () {
            $('.section').each(function () {
                let top_of_element = $(this).offset().top + 150;
                let bottom_of_element = $(this).offset().top + $(this).outerHeight();
                let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                let top_of_screen = $(window).scrollTop();
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
                    $(this).addClass('is-visible');
                }
            });
        };
        $.fn.initFadeIn();
        $(window).scroll(function () {
            $.fn.initFadeIn();
        });
    },

    initSwiperSliders() {
        const imagesSlider = new Swiper('.images-slider', {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            pagination: {
                el: ".images-slider .swiper-pagination",
                clickable: true,
            },
        });

        const reviewsSlider = new Swiper('.reviews-slider', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
            pagination: {
                el: ".reviews-slider .swiper-pagination",
                clickable: true,
            },
        });
    },

    pageheaderScroll() {
        $('.pageheader-scroll').on('click', function () {
            $('html, body').animate({
                scrollTop: $(window).height() - 35
            }, 'slow');
        });
    },

    toggleActiveFilterStates() {
        $(document).on('click', '.section-cases-overview .filter-categories .filter-link-item, .section-news-overview .filter-categories .filter-link-item', function () {
            e.preventDefault();
            if (!$(this).hasClass('is-active')) {
                $('.section-cases-overview .filter-categories .filter-link-item').each(function () {
                    if ($(this).hasClass('is-active')) {
                        $(this).removeClass('is-active');
                    }
                });

                $(this).addClass('is-active');
            }
        });
    },

    removeAndShowNavigationOnScroll() {

        var lastScrollTopPosition;

        let header = document.getElementById('header');

        window.addEventListener('scroll', function () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > lastScrollTopPosition) {
                if (window.innerWidth > 1024) {
                    header.style.top = '-80px';
                } else {
                    header.style.top = '-70px';
                }
            } else {
                header.style.top = '0';
            }

            lastScrollTopPosition = scrollTop;
        });
    },

    openMobileAppointment() {

        if ($(window).width() <= 1024) {
            $('.sticky-appointment .title').on('click', function () {
                $('body').addClass('is-locked');
                $('.sticky-appointment').addClass('open');
                $('.appointment-overlay').addClass('is-visible');
                $('.sticky-appointment .appointment-form').show();
                $('.sticky-appointment .title').addClass('visible');
                $('.sticky-appointment .appointment-elements .appointment-content .subtitle').addClass('visible');
            });

            $('.close-appointment, .appointment-overlay').on('click', function () {
                $('body').toggleClass('is-locked');
                $('.sticky-appointment').toggleClass('open');
                $('.sticky-appointment .appointment-form').toggle();
                $('.sticky-appointment .appointment-elements .appointment-content .subtitle').toggleClass('visible');
                $('.sticky-appointment .title').toggleClass('visible');
                $('.appointment-overlay').toggleClass('is-visible');
            });
        }
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        var $root = $('html, body');

        $('a[href^="#"]:not(.open-popup)').click(function (e) {
            e.preventDefault();
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 100
            }, 500);

            return false;
        });
    },
};
$(document).ready($.proxy(app.init, app));
